/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.entities.create.availability.typesModal.controllers', [
  'ui.bootstrap',
  'acme.common.service.helpers'
])

.controller('EntitiesCreateAvailabilityTypesModalController', ['$scope', '$uibModalInstance', 'HelpersService', 'resourceTypes', 'selectedResourceTypes', 'skillLabels', function($scope, $uibModalInstance, HelpersService, resourceTypes, selectedResourceTypes, skillLabels) {

    $scope.errors = [];

    $scope.model = {
      title: '',
      types: [],
      labels: {}
    };

    $scope.init = function() {
      $scope.addTypes(resourceTypes);
      $scope.model.types[0].selected = false;
      $scope.unselectAll();
      $scope.toggleSelected(selectedResourceTypes || []);
      $scope.model.labels = skillLabels;
      $scope.model.title = $scope.model.labels.singularCap + ' Availability';
    };

    $scope.addTypes = function(types) {
      $scope.model.types = [
        { id: 'all', name: 'All types' }
      ];

      if (types instanceof Array) {
        $scope.model.types = $scope.model.types.concat(angular.copy(types));
      }
    };

    $scope.toggleType = function(type) {
      type.selected = !type.selected;
      if (type.id === 'all') {
        if (type.selected) {
          $scope.unselectAll(true);
        }
      }else{
        $scope.model.types[0].selected = false;
      }
    };

    $scope.toggleSelected = function(types) {

      var i, ii,
        j, jj;

      if (types instanceof Array && types.length) {
        for (i=0,ii=$scope.model.types.length;i<ii;i++) {
          for (j=0,jj=types.length;j<jj;j++) {
            if ($scope.model.types[i].id === types[j].id) {
              $scope.model.types[i].selected = true;
            }
          }
        }
      }else{
        $scope.model.types[0].selected = true;
      }

    };

    $scope.unselectAll = function(ignoreAll) {

      var i, ii;

      for (i=0,ii=$scope.model.types.length;i<ii;i++) {
        if (ignoreAll && $scope.model.types[i].id !== 'all') {
          $scope.model.types[i].selected = false;
        }
      }

    };


    $scope.selectAll = function(ignoreAll) {

      var i, ii;

      for (i=0,ii=$scope.model.types.length;i<ii;i++) {
        if (ignoreAll && $scope.model.types[i].id !== 'all') {
          $scope.model.types[i].selected = true;
        }
      }

    };

    $scope.getSelected = function() {

      var i, ii,
          tmp,
          r = [];

      for (i=0,ii=$scope.model.types.length;i<ii;i++) {
        if ($scope.model.types[i].selected && $scope.model.types[i].id !== 'all') {

          tmp = angular.copy($scope.model.types[i]);

          tmp.selected = null;
          delete tmp.selected;

          r.push(tmp);
        }
      }

      return r;

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.getSelected());
    };

    $scope.init();

}]);